import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import routes from '../routes/route';
import { IconType } from '../components/atoms/icon/icon';

export default {
  attributeName: 'key',
  isDragable: false,
  canOpen: true,
  createPath: routes.CREDENTIAL_KEY_NEW,
  editURL: routes.CREDENTIAL_KEY_EDIT,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  emptyMessage: "You don't have organizations, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'api_key',
      label: 'Api Key',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '12rem',
      helpText: 'Api Key',
      canOrder: true,
      canFilter: true,
    },
    {
      attributeName: 'api_secret',
      label: 'Api Secret',
      type: FormInputTypes.TEXT_INPUT.PASSWORD,
      width: '20rem',
      helpText: 'Api Secret',
      canOrder: false,
      canFilter: false,
    },
    {
      attributeName: 'expirationEpoch',
      label: 'Expiration Time',
      helpText: 'Date of the expiration',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      sendAlwaysAtCreate: true,
    },
    {
      attributeName: 'isValid',
      label: 'Is Valid',
      type: FormInputTypes.CHECKBOX,
      width: '6rem',
      helpText: 'Indicates if is valid',
      canOrder: true,
      canFilter: false,
      canEdit: true,
    },
     {
      attributeName: 'tokens',
      label:'Api Credential Tokens',
      type: FormInputTypes.LINK,
      icon: IconType.INFO,
      width: '4rem',
      target:'_blank',
      iconSize:'2x',
      iconColor:'#17a2b8',
      helpText: 'Tokens in this credential',
    },
    /*{
      attributeName: 'devices',
      label:'Blocked devices',
      type: FormInputTypes.LINK,
      icon: IconType.CATALOG,
      width: '4rem',
      target:'_self',
      iconSize:'2x',
      iconColor:'#3e12df',
      helpText: 'Tokens in this credential',
    },  */
  ],
};